export default __webpack_public_path__ + "static/media/AnyConv.com__Inter-ExtraBold.e6cd1b42.ttf";